import DOMPurify from 'dompurify';
import { Button, ModalDialog, ModalOverlay } from '@flos/react-ui';
import { type ViewInformationModalProps } from '../../config/modalConfig';
import { useHippoText } from '../../hooks/useHippoText';

const ViewHippoInformationModal = ({
    showModal,
    closeModal,
    modalProps
}: {
    showModal: boolean;
    closeModal: () => void;
    modalProps: ViewInformationModalProps;
}): React.JSX.Element => {
    const getHippoText = useHippoText();

    return (
        <ModalOverlay
            isOpen={showModal}
            onDismiss={() => {
                closeModal();
            }}
        >
            <ModalDialog
                closeIconHandler={() => {
                    closeModal();
                }}
            >
                <div className="u-spacing-inset-l">
                    <div className="u-spacing-inset-l--stretch-max">
                        <h4 className="u-spacing-stack-sm">
                            {DOMPurify.sanitize(getHippoText(modalProps.title))}
                        </h4>
                        <p
                            className="u-spacing-stack-sm"
                            dangerouslySetInnerHTML={{
                                __html: DOMPurify.sanitize(getHippoText(modalProps.description))
                            }}
                        />
                    </div>
                    <Button
                        onClick={() => {
                            closeModal();
                        }}
                    >
                        {getHippoText('DSS-COMMON-CLOSE')}
                    </Button>
                </div>
            </ModalDialog>
        </ModalOverlay>
    );
};

export default ViewHippoInformationModal;
